import { Record, Map } from 'immutable'
import { UserStatus } from './constants'

export const Avatars = Record({
  image200: undefined,
  squareCropImage200: undefined,
})

export const Enrichment = Record({
  bio: null,
  city: null,
  country: null,
  display_location: null,
  display_name: null,
  employment_name: null,
  employment_role: null,
  employment_seniority: null,
  employment_title: null,
  first_name: null,
  gender: null,
  github_followers: null,
  github_handle: null,
  twitter_followers: null,
  twitter_handle: null,
  last_name: null,
  latitude: null,
  linkedin_handle: null,
  longitude: null,
  site: null,
  state: null,
})

export const User = Record({
  id: undefined,
  orgId: undefined,
  name: undefined,
  alias: null,
  availability: 'OFFLINE',
  avatarUrl: undefined,
  avatars: Avatars(),
  bot: false,
  createdAt: undefined,
  email: undefined,
  externalId: null,
  gates: Map(),
  scopes: [],
  roles: [],
  locale: null,
  phone: null,
  profile: null,
  role: undefined,
  slackUserId: null,
  status: UserStatus.ARCHIVED,
  timezone: null,
  type: undefined,
  verified: false,
  teams: [],
  workspaceRoles: [],
  features: [],
})

export const BareUser = Record({
  id: undefined,
  type: undefined,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/models.js